import { Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { motion } from 'motion/react';

export function StickyCallDock() {
  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1 }}
      className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white/95 backdrop-blur-md border-t border-border shadow-lg"
    >
      <div className="container mx-auto px-4 py-3 flex gap-3">
        <Button asChild className="flex-1 h-12">
          <a href="tel:6468999891" className="flex items-center justify-center gap-2">
            <Phone className="w-4 h-4" />
            Call Now
          </a>
        </Button>
        <Button
          asChild
          variant="outline"
          className="flex-1 h-12 border-2 hover:bg-primary/5"
        >
          <a
            href="https://wa.me/16468999891"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp
          </a>
        </Button>
      </div>
    </motion.div>
  );
}
